// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Callout-module__ui-Callout--f90_w {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding: 12px;
  border-radius: 12px;
  background-color: var(--chaek-color-surface-subtle);
  color: #1a1a1a;
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.8125rem; /* 13px */
  font-weight: 400;
  line-height: 19.5px;
  letter-spacing: -0.4262px;
  overflow: hidden;
  word-break: break-word;
}

.Callout-module__leading--ZB7nt {
  display: inline-flex;
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  align-items: center;
  justify-content: center;
}

.Callout-module__leading--ZB7nt > :where(img, svg) {
  display: block;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Callout/Callout.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,cAAc;EACd,iDAAiD;EACjD,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd","sourcesContent":[".ui-Callout {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  padding: 12px;\n  border-radius: 12px;\n  background-color: var(--chaek-color-surface-subtle);\n  color: #1a1a1a;\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 400;\n  line-height: 19.5px;\n  letter-spacing: -0.4262px;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.leading {\n  display: inline-flex;\n  width: 14px;\n  height: 14px;\n  flex: 0 0 14px;\n  align-items: center;\n  justify-content: center;\n}\n\n.leading > :where(img, svg) {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Callout": `Callout-module__ui-Callout--f90_w`,
	"leading": `Callout-module__leading--ZB7nt`
};
export default ___CSS_LOADER_EXPORT___;
